export const getUrl = (path: string = '') => {
  const url = new URL(path, import.meta.env.VITE_APP_URL ?? 'http://localhost')
  return url.toString()
}

export const getAppUrl = (path: string = '') => {
  const url = new URL(path, import.meta.env.VITE_API_URL ?? 'http://localhost')
  return url.toString()
}

export const getImageUrl = (path: string) => {
  return new URL(path, import.meta.url).href
}
